import jsCookie from 'js-cookie';
import { VISION_INSURANCE_SPECIALTIES, DENTAL_INSURANCE_SPECIALTIES } from '@zocdoc/components/src/constants';
import { USER_SPECIALTY_INSURANCE_TYPES } from '../constants';

const CHOOSE_INSURANCE_LATER = {
    carrierId: '-1',
    planId: '-1',
};

export const getInsuranceFromSpecialtyIds = ({
    cookies,
    insuranceFromBrandConfig,
    insuranceQueryParameters = {},
    specialtyIds,
}) => {
    // insurance fallback priority url > cookie > default in theme
    // however, some directory hospitals (e.g. GHP) only allow one insurance carrier.
    // and the carrier id is set in the theme as a default carrier.
    // Thus, if given insurance carrier id does not match to the default,
    // We should return id -1, 'I will choose my insurance later'
    let insuranceToUse = insuranceQueryParameters;
    if (!insuranceToUse.carrierId) {
        insuranceToUse = getInsuranceFromCookie(specialtyIds, cookies);
    }

    if (!insuranceToUse.planId) {
        insuranceToUse.planId = CHOOSE_INSURANCE_LATER.planId;
    }

    if (insuranceFromBrandConfig.carrierId && insuranceToUse.carrierId) {
        return (insuranceToUse.carrierId === insuranceFromBrandConfig.carrierId)
            ? insuranceToUse
            : CHOOSE_INSURANCE_LATER;
    } else if (!insuranceFromBrandConfig.carrierId && insuranceToUse.carrierId) {
        return insuranceToUse;
    } else if (insuranceFromBrandConfig.carrierId && !insuranceToUse.carrierId) {
        return insuranceFromBrandConfig;
    } else {
        return CHOOSE_INSURANCE_LATER;
    }
};

const getInsuranceFromCookie = (specialtyIds, cookies) => {
    if (specialtyIds.some(isVision)) {
        return {
            carrierId: cookies.vCarrierId,
            planId: cookies.vPlanId,
        };
    } else if (specialtyIds.some(isDental)) {
        return {
            carrierId: cookies.dCarrierId,
            planId: cookies.dPlanId,
        };
    } else {
        return {
            carrierId: cookies.hCarrierId,
            planId: cookies.hPlanId,
        };
    }
};

export const getCookiedInsuranceFromUserSpecialtyType = specialtyType => {
    // This function returns a carrier and plan Id from a user specialty type
    // If the corresponding cookie doesn't exist, it returns null
    let carrierId;
    let planId;
    switch (specialtyType) {
        case USER_SPECIALTY_INSURANCE_TYPES.DENTAL:
            carrierId = jsCookie.get('dCarrierId');
            planId = jsCookie.get('dPlanId');
            if (carrierId && planId) {
                return {
                    carrierId,
                    planId,
                };
            }
            break;
        case USER_SPECIALTY_INSURANCE_TYPES.MEDICAL:
            carrierId = jsCookie.get('hCarrierId');
            planId = jsCookie.get('hPlanId');
            if (carrierId && planId) {
                return {
                    carrierId,
                    planId,
                };
            }
            break;
        case USER_SPECIALTY_INSURANCE_TYPES.VISION:
            carrierId = jsCookie.get('vCarrierId');
            planId = jsCookie.get('vPlanId');
            if (carrierId && planId && carrierId !== -1 && planId !== -1) {
                return {
                    carrierId,
                    planId,
                };
            }
            break;
        default:
            return null;
    }
    return null;
};

export const getUserSpecialtyTypeFromSpecialtyId = specialtyId => {
    if (isDental(specialtyId)) {
        return USER_SPECIALTY_INSURANCE_TYPES.DENTAL;
    }
    if (isVision(specialtyId)) {
        return USER_SPECIALTY_INSURANCE_TYPES.VISION;
    }
    return USER_SPECIALTY_INSURANCE_TYPES.MEDICAL;
};

const isDental = specialtyId => {
    return DENTAL_INSURANCE_SPECIALTIES.has(specialtyId);
};

const isVision = specialtyId => {
    return VISION_INSURANCE_SPECIALTIES.has(specialtyId);
};
